import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './Pages/Layout'
import Home from './Pages/Home'
import MilkAssociationCaseStudy from './Components/Old/CaseStudies/MilkAssociationCaseStudy'
import TherapyClinicCaseStudy from './Components/Old/CaseStudies/TherapyClinicCaseStudy'
import PrivacyPolicy from './Pages/PrivacyPolicy'
import TermsOfService from './Pages/TermsOfServices'
import DataDeletionInstruction from './Pages/DataDeletionInstructuion'


const About = () => <h2>About</h2>

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />

          <Route path="about" element={<About />} />
          
          <Route path="/case-studies/milk-association-system" element={<MilkAssociationCaseStudy />} />
          <Route path="/case-studies/therapy-clinic-system" element={<TherapyClinicCaseStudy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/data-deletion-instruction" element={<DataDeletionInstruction />} />
   
   
   
        </Route>
      </Routes>
    </Router>
  )
}

export default App;